// src/contexts/StaticValuesContext.tsx
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { membershipTypesDummy, pricingListDummy } from '../static/tmpStaticValues';

export interface StaticValuesContextType {
    pricingList: any[];
    membershipTypes: any[];
    getPricingList: () => any[];
    getMembershipTypes: () => any[];
}

const StaticValuesContext = createContext<StaticValuesContextType | undefined>(undefined);

export function StaticValuesProvider({ children }: { children: ReactNode }) {
    const [pricingList, setPricingList] = useState<any[]>([]);
    const [membershipTypes, setMembershipTypes] = useState<any[]>([]);

    useEffect(() => {
        const fetchStaticValues = async () => {
            try {
                // const [pricingResponse, membershipResponse] = await Promise.all([
                //   axios.get('/api/static/pricingList'),
                //   axios.get('/api/static/membershipTypes'),
                // ])
                const [pricingResponse, membershipResponse] = [pricingListDummy, membershipTypesDummy];

                setPricingList(pricingResponse.data);
                setMembershipTypes(membershipResponse.data);
            } catch (error) {
                console.error('Failed to fetch static values', error);
            }
        };

        fetchStaticValues();
    }, []);

    const getPricingList = () => pricingList;
    const getMembershipTypes = () => membershipTypes;

    const value = React.useMemo(
        () => ({
            pricingList,
            membershipTypes,
            getPricingList,
            getMembershipTypes,
        }),
        [pricingList, membershipTypes],
    );

    return <StaticValuesContext.Provider value={value}>{children}</StaticValuesContext.Provider>;
}

export const useStaticValues = () => {
    const context = useContext(StaticValuesContext);
    if (context === undefined) {
        throw new Error('useStaticValues must be used within a StaticValuesProvider');
    }
    return context;
};
